export default "__VITE_ASSET__B_lSbQ1r__"